module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n5r9n3r-1df173bffde75cfa9cf475a645e865b4.svg";